<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <p class="text-muted mb-0 hover-cursor">&nbsp;Invoicing / Pending&nbsp;/&nbsp;</p>
            <p class="text-primary mb-0 hover-cursor">Detail</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="container">
            <!-- Progress Box -->
            <div class="row justify-content-center align-items-center mt-4">
              <div class="col-lg-12 col-sm-12">
                <div :class="'invoice-action-box-progress'" v-if="jurnalStatus == 'On Progress' || jurnalStatus == 'Pending'">
                  <div class="row">
                    <div class="col-12 mb-1 mt-1">
                      <div class="container ">
                        <div class="row">
                          <div class="col-lg-12 col-sm-12">
                            <div class="row">
                              <div class="col-lg-12 col-sm-12" style="display : flex; justify-content : space-between">
                                <div>
                                  <img src="@/assets/icon/icon-danger.png" style="width: 16px; margin-bottom : 2px"/>
                                  <span class="progress-box-title ml-2" style="color: #F06400;"> On Progress </span>
                                  <span class="progress-box-description ml-2" style="color: #F06400;">Invoice is currently in the queue </span>
                                </div>
                                <div>
                                  <span class="progress-box-description ml-2" style="color: #F06400;">{{jurnalSentDate}} </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>       
                      </div>
                    </div>
                  </div>     
                </div>
              </div>
            </div>

            <div class="mb-1 mt-2">
              <!-- ROW 1 -->
              <div class="row mb-3">
                <!-- LEFT Invoice Info -->
                <div class="col-lg-9 col-md-9 col-sm-9 mb-sm-1">     
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-6 mb-sm-1">
                      <div class="mb-sm-1"><span class="bold-12">Invoice Number :</span></div>
                      <div><span class="bold-24">{{invoiceCode}}</span></div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 mb-sm-1">
                       <div class="mb-sm-1"><span class="bold-12">Jurnal ID :</span></div>
                      <div><span class="bold-24">-</span></div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6 mb-sm-1">
                      <div class="mb-sm-1"><span class="bold-12">Invoice Category :</span></div>
                      <span class="badge badge-primary invoice-category-badge">
                        <div class="ml-2 mr-2" style="margin-top :1px; margin-bottom :1px">{{invoiceType}}</div>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Right Status -->
                <div class="col-lg-3 col-md-3 col-sm-3 mb-sm-1">
                  <div class="row">
                    <div class="mb-sm-1">
                      <div class="mb-sm-1"><span class="bold-12">Status :</span></div>
                      <div>
                        <span class="badge invoice-pending-status-badge">
                          <div class="ml-2 mr-2" style="margin-top :1px; margin-bottom :1px">Pending</div>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ROW 2 -->
              <div class="container row mb-1">
                <!-- LEFT SIDE -->
                <div class="col-lg-9 col-md-9 col-sm-9 mb-sm-1">
                  <!-- Customer Infomation -->
                  <div class="row mr-2">
                    <div class="col-12 border shadow-sm rounded" style="background:#F6F7F9">
                      <div class="row border-bottom title-square-background rounded-top mb-3" style="background:#EBEEF3">
                        <div class="col-12 d-flex justify-content-between mb-1 mt-1">
                          <div class="bold-12">
                            Bill To :
                          </div>
                        </div>
                      </div>
                      <div class="bold-20 mb-2">{{companyName}}</div>
                      <div class="mb-2" style="font-size:14px">{{companyAddress}}</div>
                    </div>
                  </div>
                </div>
                <!-- RIGHT SIDE -->
                <div class="col-lg-3 col-md-3 col-sm-3 mb-sm-1">
                  <div class="row">
                    <div class="mb-1">Billing Cycle : {{ formatDate(invoiceBillingCycle,'DD MMM YYYY')}}</div>
                    <div class="mb-2">Due Date : {{formatDate(invoiceDueDate, 'DD MMM YYYY')}}</div>
                    <button class="btn btn-md btn-primary" style="width:100%" @click="showUpdateBillingDateModal">
                      <i class="fa fa-calendar" aria-hidden="true"></i>
                      Update All Billing Cycle
                    </button>
                  </div>
                </div>
    
              </div>
              <!-- ROW 3 -->
              <div class="container row mb-1">
                <!-- LEFT SIDE -->
                <div class="col-lg-12 col-md-12 col-sm-12 mb-sm-1">
                  <!-- Contact -->
                  <div class="row">
                    <div class="col-12 border shadow-sm rounded" style="background:#F6F7F9">
                      <div class="row border-bottom title-square-background rounded-top mb-2" style="background:#EBEEF3">
                        <div class="col-12 d-flex justify-content-between mb-1 mt-1">
                          <div class="bold-12">
                            Contact :
                          </div>
                        </div>
                      </div>
                      <div class="row mb-2">
                        <div class="col-10">
                          <span v-for="(email, i) in financeEmailList" :key="i">
                            <span style="color:#FFFFFF;" class="badge bg-secondary mr-1" v-if="i < 6">{{email}}</span>
                          </span>
                    
                          <span class="badge badge-primary and-other-email" @click="showEditFinanceEmailModal" v-if="financeEmailList.length > 6" >
                            and {{financeEmailList.length - 6}} others
                          </span>
                        </div>
                        
                        <div class="col-2">
                          <span class="badge bg-primary" style="cursor:pointer; float:right;" @click="showEditFinanceEmailModal">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" fill="none">
                              <path d="M4.16667 15.8333H5.35417L13.5 7.6875L12.3125 6.5L4.16667 14.6458V15.8333ZM2.5 17.5V13.9583L13.5 2.97917C13.6667 2.82639 13.8508 2.70833 14.0525 2.625C14.2542 2.54167 14.4658 2.5 14.6875 2.5C14.9097 2.5 15.125 2.54167 15.3333 2.625C15.5417 2.70833 15.7222 2.83333 15.875 3L17.0208 4.16667C17.1875 4.31944 17.3092 4.5 17.3858 4.70833C17.4625 4.91667 17.5006 5.125 17.5 5.33333C17.5 5.55556 17.4617 5.7675 17.385 5.96917C17.3083 6.17083 17.1869 6.35472 17.0208 6.52083L6.04167 17.5H2.5ZM12.8958 7.10417L12.3125 6.5L13.5 7.6875L12.8958 7.10417Z" fill="white"/>
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            
            <div class="mt-3 d-flex justify-content-between">
              <div><b class="mr-2">Details</b><span class="table-note">*Double click to edit</span></div>
            </div>

            <div class="d-flex justify-content-between mt-4">
              <div class="mb-1 d-flex">
                <div class="mr-3">
                        <button class="btn btn-primary" @click="addRow">
                          + Add Row
                        </button>
                </div>
                <div class="border border-secondary mb-2" style="border-radius : 10px;border-color:#6D788D80">
                  <div class="mt-2 mx-2 d-flex" >
                    <div class="ml-3 mr-5 d-flex">
                      <div class="mr-2">
                        <input  type="checkbox" id="checkbox-showLp" @click="confirmationPopUp('tampilkanLP')" :checked="isShowLP" v-model="inputIsShowLP">
                      </div>
                      <label for="checkbox-showLp" class="bold-12" :style="`color : ${inputIsShowLP ? '#3099F8' : ''}; margin-top: 1.5px;`">
                          Tampilkan LP
                      </label>
                    </div>
                    
                    <div class=" mr-5 d-flex">
                      <div class="mr-2">
                        <input  type="checkbox" id="checkbox-split" @click="confirmationPopUp('splitByQty')" :checked="isSplitByQty" v-model="inputIsSplitByQty">
                      </div>
                      <label  for="checkbox-split" class="bold-12" :style="`color : ${inputIsSplitByQty ? '#3099F8' : ''}; margin-top: 1.5px;`">Split by Qty</label>
                    </div>
                    <div class="mr-3 d-flex">
                      <div class="mr-2">
                        <input  
                          type="checkbox" 
                          id="checkbox-materai" 
                          @click="confirmationPopUp('materai')" 
                          :checked="isMaterai" 
                          v-model="inputIsMaterai" 
                          :disabled="!enableMaterai"
                        >
                      </div>
                      <label  
                        for="checkbox-materai" 
                        class="bold-12" 
                        :style="`color : ${inputIsMaterai ? (!enableMaterai ? '' : '#3099F8' ) : ''}; margin-top: 1.5px;`"
                        >Meterai
                      </label>
                      <div class="custom-tooltip" v-if="!enableMaterai">
                        <i
                          class="fas fa-info-circle"
                          style="width : 12px; margin-bottom : 1px; margin-left : 3px; color : #00AED6;"
                        ></i>
                        <div class="tooltiptext" style="display: grid;grid-template-columns: auto auto;column-gap: 10px;">
                          <div style="top: 50%; transform: translate(0%, 25%);"
                          >
                            <i
                              class="fas fa-info-circle"
                              style="width : 22px; color : #00AED6;"
                            ></i>
                          </div>
                          <div>
                            Meterai hanya aktif jika total transaksi lebih dari atau sama dengan Rp 5.000.000
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <div>
              <div>
                <div class="mb-2 d-flex flex-row">
                  <button class="btn btn-md btn-outline-warning mr-2" @click="showRestoreDataModal" style="font-weight :550;">
                    <i class="fa fa-history" aria-hidden="true"></i>
                    Restore All Details
                  </button>
                   <button class="btn btn-md btn-outline-success" @click="showDownloadConfirmation" style="font-weight : 550;" :disabled="loadingButtonDownload == true">
                      Download PDF
                      <img src="~@/assets/images/2.gif" style="height: 24px;" v-if="loadingButtonDownload == true">
                  </button>
                </div>
              </div>
            </div>
          </div>
            
            <InvoiceDetailTable 
              :isIgnore="false"
                :invoiceData="invoiceData" 
                :totalData="totalData" 
                :currentPage="currentPage" 
                :totalPage="totalPage" 
                :onDataChange="onInput" 
                :toDataPage="toDataPage"
                :showPage="showPage"
                :deleteRow="deleteRow"
                :setInvoiceDetailIdTobeExcluded="setInvoiceDetailIdTobeExcluded"
                :setInvoiceDetailIdTobeRestored="setInvoiceDetailIdTobeRestored"
                :setIsExclude="setIsExclude"
                :setIsRestoreAll="setIsRestoreAll"
                :loadingTable="loadingTable"
                :jurnalStatus="jurnalStatus"
                :isSplitByQty="isSplitByQty"
            />
            <div id="actions" class="mt-3 mb-5" style="display:flex; justify-content: flex-end">
                <!-- <button type="button" class="btn btn-link" style="text-decoration : none;">Delete</button> -->
                <button class="btn btn-primary btn-md" @click="submitChanges" :disabled="loadingButtonSave == true">
                  Save
                  <img src="~@/assets/images/2.gif" style="height: 24px;" v-if="loadingButtonSave == true">
                </button>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  
    <ModalUpdateInvoiceBillingDate :isExclude="isExclude" :billingCycle="newBillingCycle" :setNewBillingCycle="setNewBillingCycle" :executeChanges="modifyBillingCycle"/>
    <ModalRestoreInvoiceDetail :isRestoreAll="isRestoreAll" :restoreDetail="restoreDetail"/>
    <ModalUpdateFinanceEmailList :emailList="[...financeEmailList]" :saveChanges="updateInvoicingEmail"/>
  
    <!-- Modal disable action -->
   <div class="modal fade" id="modalDisableAction" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-scroll">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body">
            <div class="container">
                <div style="text-align : center;">
                  <div class="mt-4">
                    <img src="@/assets/icon/icon-oops.png" style="width: 90px;"/>
                  </div>
                  <div style="
                      color:#505868;
                      font-size: 32px;
                      font-weight: 600;
                      line-height: 39px;
                      text-align: center;"
                      class="mt-4"
                    >
                      Oops..
                    </div>
                    <div style="
                      color:#505868;
                      font-size: 18px;
                      font-weight: 400;
                      line-height: 21.78px;
                      text-align: center;"
                      class="mt-3"
                    >
                      Please wait, you can’t do any action at this time
                    </div>
                </div>
                <div style="text-align : center;">
                    <button class="btn btn-small btn-primary mt-3" @click="closeDisableActionModal">
                        OK
                    </button>
                </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="container">
                <div style="text-align : center;">
                    <span  
                    style="font-weight: 400;font-size:18px;line-height: 22px;text-align: center;color:#F06400;">
                      Invoice is currently in the queue
                    </span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from "moment";
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
import InvoiceDetailTable from './CustomComponent/InvoiceDetailTable.vue'
import ModalUpdateInvoiceBillingDate from './CustomComponent/ModalUpdateInvoiceBillingDate.vue'
import ModalRestoreInvoiceDetail from './CustomComponent/ModalRestoreInvoiceDetail.vue'
import ModalUpdateFinanceEmailList from './CustomComponent/ModalUpdateFinanceEmailList.vue'
import swal from 'sweetalert';
export default {
  name: 'InvoiceCreationPage',
  components:{
    SideBar,
    Multiselect,
    InvoiceDetailTable, 
    ModalUpdateInvoiceBillingDate,
    ModalRestoreInvoiceDetail,
    ModalUpdateFinanceEmailList,
  },
  data () {
    return {
      admin:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      viewInvoicing : false,
      viewPendingInvoice : false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      dataComplain: [],
      loadingTable: true,
      totalPage:0,
      totalData:0,
      currentPage:1,
      itemPerPage: 10,
      invoiceData : [],
      changedRowsOldData : [],
      deletedRowData : [],
      isSplitByQty : false,
      inputIsSplitByQty : false,
      isShowLP : false,
      inputIsShowLP : false,
      isMaterai : false,
      inputIsMaterai : false,
      companyName : '',
      companyAddress : '',
      financeEmailList : [],
      invoiceBillingCycle : '',
      invoiceDueDate : '',
      invoiceId : '',
      invoiceCode :'',
      invoiceDetailIdTobeExcluded : '',
      invoiceDetailIdTobeRestored : [],
      newBillingCycle : '',
      isExclude : false,
      isRestoreAll : false,
      jurnalStatus : '',
      jurnalSentDate :'',
      invoiceType :'',
      loadingButtonSave : false,
      loadingButtonDownload : false,
      enableMaterai: false,
      currentTax: 0,
    }
  },
  methods: {
    forceFileDownload(response, filename) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    showDownloadConfirmation() {
      swal({
        icon : 'warning',
        text: "Invoice masih PENDING. Apakah Anda tetap akan mengunduh PDF ?",
        buttons : {
          cancel : 'Tidak',
          save :'Ya',
        },
        dangerMode : true
      }).then((result) => {
        if (result) {
          this.downloadInvoice()
        } else  {
          return
        }
      });
    },
      downloadInvoice() {
      this.loadingButtonDownload = true
      this.$http.post(
        process.env.DOWNLOAD_INVOICE, 
        {
          invoiceId: this.invoiceId,
          isPending : true,
        },
        { 
          timeout: 20 * 6000,
          responseType: "arraybuffer",
          headers: { 'Asani-Token': localStorage.getItem('jwt') } 
        })
        .then(res => {
          const responseType = res.config.responseType
    
          let responseStatus = ''
          let responseMessage = ''
          if (responseType && responseType == 'arraybuffer') {
            const responseBufferJSON = Buffer.from(res.data).toJSON();
            if (responseBufferJSON.data[0] == 123) {
              let responseString = ''
              responseBufferJSON.data.forEach(item => {
                responseString = responseString + String.fromCharCode(item)
              })
              const response = JSON.parse(responseString)
              responseStatus = response.status
              responseMessage = response.message
              console.log('status')
              console.log(responseStatus)
            } else {
              this.forceFileDownload(res,"invoice_" + this.invoiceCode + ".pdf");
              this.loadingButtonDownload = false
            }
          }
          if(responseStatus == 400) {  
           swal("Sorry", responseMessage , "error", {
              button: "Close"
              });
              this.loadingButtonDownload = false
          } else if(responseStatus == 303) {
            swal('Oops...','Invoice sudah berhasil dikirim ke jurnal, Klik OK untuk masuk ke detail invoice','error').then(() => {
              this.$router.push({path:`/invoicing/detail/${this.$route.query.invoiceId}`, query: {
                  page : 1,
                  itemPerPage : 10,
                  companyName : this.$route.query.companyName,
                  invoiceId : this.$route.query.invoiceId,
                  jurnalId : response.data.data.data.jurnalTransactionId,
                }})
            })
          }
          
        })
        .catch(error => {
          this.loadingButtonDownload = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    closeDisableActionModal() {
      this.inputIsShowLP = this.isShowLP
      this.inputIsSplitByQty = this.isSplitByQty
      this.inputIsMaterai = this.isMaterai
      this.closeModal('DisableAction')
    },
    confirmationPopUp(type) {
      if(this.jurnalStatus == 'Pending' || this.jurnalStatus == 'On Progress') {
        $(`#modalDisableAction`).modal("show");
      } else {
        let popUpMessage = ''
        switch (type) {
          case 'tampilkanLP' : {
            if (!this.isShowLP) {
              popUpMessage = 'ingin menampilkan LP'
            }else{
              popUpMessage = 'tidak ingin menampilkan LP'
            }
            this.inputIsShowLP = !this.inputIsShowLP
            break;
          }
          case 'splitByQty' : {
            if (!this.isSplitByQty) {
              popUpMessage = 'ingin split data by qty'
            }else{
              popUpMessage = 'tidak ingin split data by qty'
            }
            this.inputIsSplitByQty = !this.inputIsSplitByQty
            break;
          }
          case 'materai' : {
            if (!this.isMaterai) {
              popUpMessage = 'ingin menampilkan biaya materai'
            }else{
              popUpMessage = 'tidak ingin menampilkan biaya materai'
            }
            this.inputIsMaterai = !this.inputIsMaterai
          }
        }

        swal({
          text : `Apakah anda yakin ${popUpMessage}`,
          icon : 'warning',
          buttons : {
            cancel : 'cancel',
            save :'save',
          },
          dangerMode : true
        }).then((value) => {
          if(!value) {
            switch (type) {
              case 'tampilkanLP' : {
                this.inputIsShowLP = !this.inputIsShowLP
                break;
              }
              case 'splitByQty' : {
                this.inputIsSplitByQty = !this.inputIsSplitByQty
                break;
              }
              case 'materai' : {
                this.inputIsMaterai = !this.inputIsMaterai
              }
            }
          } else {
            this.$http.post(`${process.env.UPDATE_PENDING_INVOICE_DETAIL}`,
            {
              invoiceId: this.invoiceId,
              showLP: this.inputIsShowLP,
              splitByQty: this.inputIsSplitByQty,
              materaiUsed : this.inputIsMaterai,
              patchBy: Number(localStorage.getItem('admin_id')),
              patchByName: localStorage.getItem('admin_name'),
              patchInvoiceDetails: null,
              isPending : true,
            },
            {
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
              if(response.data.status != 200) {
                if(response.data.status === 303) {
                  swal('Opps...','Invoice sudah berhasil dikirim ke jurnal, Klik OK untuk masuk ke detail invoice','error').then(() => {
                    this.$router.push({path:`/invoicing/detail/${this.$route.query.invoiceId}`, query: {
                        page : 1,
                        itemPerPage : 10,
                        companyName : this.$route.query.companyName,
                        invoiceId : this.$route.query.invoiceId,
                        jurnalId : '',
                      }})
                  })
                } else {
                  swal('Error', response.data.message, 'error').then(() => {
                    // window.location.reload();
                  })
                }
                
              } else {
                swal('Success','Berhasil menyimpan perubahan', 'success' ).then(() => {
                  // this.getData()
                  window.location.reload();
                })
              }
            })
            .catch(error => {
              swal("Sorry", error.response.data.message, "error", {
                button: "Ok",
              }).then(v => {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                }
              })
            })
          }
        })
      }
      
    },
    setNewBillingCycle(newdata) {
      // for update all billing cycle
      this.newBillingCycle = newdata
    },
    setIsRestoreAll(data) {
      this.isRestoreAll = data;
    },
    setIsExclude(data) {
      // data : Boolean
      this.isExclude = data
    },
    setInvoiceDetailIdTobeExcluded(ids) {
      this.invoiceDetailIdTobeExcluded = `${ids}`
    },
    setInvoiceDetailIdTobeRestored(stringId) {
      this.invoiceDetailIdTobeRestored = [...stringId.split(',').map(item => Number(item))]
    },
    modifyBillingCycle(isChangeAllBillingDate) {
      var self = this
      if(this.isExclude) {
        // For Exclude
        this.$http.post(`${process.env.EXCLUDE_INVOICE_BILLING_CYCLE}`,
        {
          invoiceId: this.invoiceId,
          invoiceDetailIds: this.invoiceDetailIdTobeExcluded,
          billingCycle: this.newBillingCycle,
          isPending:true,
        },
        {
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if(response.data.status != 200) {
            if(response.data.status == 303) {
              swal('Oops...','Invoice sudah berhasil dikirim ke jurnal, Klik OK untuk masuk ke detail invoice','error').then(() => {
                this.$router.push({path:`/invoicing/detail/${this.$route.query.invoiceId}`, query: {
                  page : 1,
                  itemPerPage : 10,
                  companyName : this.$route.query.companyName,
                  invoiceId : this.$route.query.invoiceId,
                  jurnalId : '',
                }})
              })
            } else {
              swal('Error', response.data.message, 'error').then(() => {
                // window.location.reload();
                this.newBillingCycle = this.invoiceBillingCycle
              })
            }
          } else {
            swal('Success','Berhasil menyimpan perubahan', 'success' ).then(() => {
              window.location.reload();
            })
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            } else {
              self.newBillingCycle = self.invoiceBillingCycle
            }
          })
        })
      } else {
        // For modify All
        this.$http.post(`${process.env.UPDATE_INVOICE_BILLING_CYCLE}`,
        {
          invoiceId: this.invoiceId,
          billingCycle: this.newBillingCycle,
          allUpdate : isChangeAllBillingDate,
          isPending: true,
        },
        {
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if(response.data.status != 200) {
            if(response.data.status == 303) {
              swal('Oops...','Invoice sudah berhasil dikirim ke jurnal, Klik OK untuk masuk ke detail invoice'
              ,'error').then(() => {
                this.$router.push({path:`/invoicing/detail/${this.$route.query.invoiceId}`, query: {
                    page : 1,
                    itemPerPage : 10,
                    companyName : this.$route.query.companyName,
                    invoiceId : this.$route.query.invoiceId,
                    jurnalId : '',
                  }})
              })
            } else {
              swal('Error', response.data.message, 'error').then(() => {
                this.newBillingCycle = this.invoiceBillingCycle
              })
            }
          } else {
            swal('Success','Berhasil menyimpan perubahan', 'success' ).then(() => {
              window.location.reload();
            })
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            } else {
              this.newBillingCycle = this.invoiceBillingCycle
            }
          })
        })
      }

      
    },
    restoreDetail() {
      this.$http.post(`${process.env.RESTORE_DETAIL_INVOICE}`,
        {
          invoiceId: this.invoiceId,
          invoiceDetailsId: this.isRestoreAll ? [] : this.invoiceDetailIdTobeRestored,
          all : this.isRestoreAll,
          isPending:true,
        },
        {
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if(response.data.status != 200) {
            if(response.data.status == 303) {
              swal('Oops...','Invoice sudah berhasil dikirim ke jurnal, Klik OK untuk masuk ke detail invoice','error').then(() => {
                this.$router.push({path:`/invoicing/detail/${this.$route.query.invoiceId}`, query: {
                    page : 1,
                    itemPerPage : 10,
                    companyName : this.$route.query.companyName,
                    invoiceId : this.$route.query.invoiceId,
                    jurnalId : '',
                  }})
              })
            } else {
              swal('Error', response.data.message, 'error').then(() => {
                this.invoiceDetailIdTobeRestored = ''
                window.location.reload()
              })
            }
          } else {
            swal('Success',response.data.message, 'success' ).then(() => {
              this.invoiceDetailIdTobeRestored = ''
              window.location.reload();
            })
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            } else {
              this.invoiceDetailIdTobeRestored = ''
            }
          })
        })
    },
    formatDate(value, dateFormat) {
      return moment(value).format(dateFormat)
    },
    updateInvoicingEmail (emailList) {
       this.$http.post(`${process.env.UPDATE_INVOICING_EMAIL}`,
      {
        id: this.invoiceId,
        patchBy: Number(localStorage.getItem('admin_id')),
        patchByName: localStorage.getItem('admin_name'),
        emails: emailList,
        isPending : true,
      },
      {
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if(response.data.status != 200) {
          if(response.data.status == 303) {
            swal('Oops...','Invoice sudah berhasil dikirim ke jurnal, Klik OK untuk masuk ke detail invoice','error').then(() => {
              this.$router.push({path:`/invoicing/detail/${this.$route.query.invoiceId}`, query: {
                  page : 1,
                  itemPerPage : 10,
                  companyName : this.$route.query.companyName,
                  invoiceId : this.$route.query.invoiceId,
                  jurnalId : '',
                }})
            })
          } else {
            swal('Error', response.data.message, 'error').then(() => {
              // window.location.reload();
            })
          }
          
        } else {
          swal('Success','Berhasil menyimpan perubahan', 'success' ).then(() => {
            this.closeModal('UpdateFinanceEmailList')
            window.location.reload();
          })
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          } else {
            window.location.reload();
          }
        })
      })
    },
    showPage (dataPerPage) {
      this.loadingTable = true
      this.$router.push({path:'/invoicing/pending/detail', query: {
          companyName: this.$route.query.companyName,
          invoiceId: this.$route.query.invoiceId,
          page: 1,
          itemPerPage : dataPerPage,
        }
      })
    },
    toDataPage(pagePost){
        this.loadingTable = true
        this.$router.push({
            path:'/invoicing/pending/detail', 
            query: {
              companyName: this.$route.query.companyName,
              invoiceId: this.$route.query.invoiceId,
              page: pagePost,
              itemPerPage : this.itemPerPage,
            }
          })
        // this.getData()
      },
    toPage(e) {
        if (e == '/product') {
        localStorage.setItem('itemPerPage', 10)
      }
        this.$router.push(e)
        localStorage.removeItem('endrent_cache')
    },
    showEditFinanceEmailModal () {
      $(`#modalUpdateFinanceEmailList`).modal("show");
    },
    formatPrice(value) {
      let val = value  ? Number(value).toFixed(2) : Number(0).toFixed(2)
      const round = val.toString().split('.')[0]
      const decimal = val.toString().split('.')[1]

      let result = round.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      result = decimal ? `${result},${decimal}` : `${result},00`

      return result
    },
    columnNameConverter(column) {
      switch(column) {
        case 'uniqueCode' : {
          return 'No. ID'
        }

        case 'qty' : {
          return 'Qty'
        }

        case 'productCode' : {
          return 'Nama Barang'
        }

        case 'descriptions' : {
          return 'Keterangan'
        } 

        case 'amount' : {
          return 'Harga Satuan'
        }

        case 'amountDiscount' : {
          return 'Diskon'
        }

        case 'amountTax' : {
          return 'Pajak'
        }

        case 'amountTotal' : {
          return 'Jumlah'
        }
      }
    },
    submitChanges() {
      if(this.jurnalStatus == 'Pending' || this.jurnalStatus == 'On Progress') {
        $(`#modalDisableAction`).modal("show");
      } else {
        this.loadingButtonSave = true
        const newPendingInvoiceDetailData = this.invoiceData.map((item) => {
          const {invoiceDetailId, qty, productName, descriptions, amount, amountDiscount, amountTax, amountTotal, groupedIds, isAdditionalItem} = item
          let updateLog = []
          if(item.descriptionPatch && (item.descriptionPatch == 'Added' || item.descriptionPatch == 'Deleted') ) {
            updateLog = item.descriptionPatch
          } else {
            const moneyField = ['amount', 'amountDiscount', 'amountTax', 'amountTotal']
            const oldData = this.changedRowsOldData.find(item => item.invoiceDetailId == invoiceDetailId)
            if(oldData) {
              Object.keys(oldData).forEach(key => {
                if(oldData[key] !== item[key]) {
                  let log = moneyField.includes(key) ? `${this.columnNameConverter(key)} : ${this.formatPrice(oldData[key])} ke ${this.formatPrice(item[key])}` : `${this.columnNameConverter(key)} : ${oldData[key]} ke ${item[key]}`
                  updateLog.push(log)
                }
              })
            } 
          }
      
          return {
            invoiceDetailId: invoiceDetailId ? invoiceDetailId : 0,
            qty : Number(qty),
            productName,
            descriptions,
            amount : Number(amount),
            amountDiscount : Number(amountDiscount),
            amountTax : Number(amountTax),
            amountTotal : Number(amountTotal),
            groupedIds,
            delete: item.delete ? true : false,
            isAdditionalItem,
            descriptionPatch : updateLog,
          }
        })

        this.$http.post(`${process.env.UPDATE_PENDING_INVOICE_DETAIL}`,
        {
          invoiceId: this.invoiceId,
          showLP: this.inputIsShowLP,
          splitByQty: this.inputIsSplitByQty,
          materaiUsed : this.inputIsMaterai,
          patchBy: Number(localStorage.getItem('admin_id')),
          patchByName: localStorage.getItem('admin_name'),
          patchInvoiceDetails: newPendingInvoiceDetailData,
          isPending : true,
        },
        {
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          this.loadingButtonSave = false
          if(response.data.status != 200) {
            if(response.data.status === 303) {
              swal('Error','Invoice sudah berhasil dikirim ke jurnal, Klik OK untuk masuk ke detail invoice','error').then(() => {
                this.$router.push({path:`/invoicing/detail/${this.$route.query.invoiceId}`, query: {
                  page : 1,
                  itemPerPage : 10,
                  companyName : this.$route.query.companyName,
                  invoiceId : this.$route.query.invoiceId,
                  jurnalId : '',
                }})
              })
            } else {
              swal('Error', response.data.message, 'error').then(() => {
                // window.location.reload();
              })
            }
          } else {
            swal('Success','Berhasil menyimpan perubahan', 'success' ).then(() => {
              window.location.reload();
            })
          }
        })
        .catch(error => {
          this.loadingButtonSave = false
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
      }
    },
    addRow() {
      if(this.jurnalStatus == 'Pending' || this.jurnalStatus == 'On Progress') {
        $(`#modalDisableAction`).modal("show");
      } else {
        this.invoiceData = [{
          qty : 0,
          productName : '-',
          descriptions : '-',
          amount : 0,
          amountDiscount : 0,
          amountTax :0,
          amountTotal : 0,
          newRow : true,
          isAdditionalItem : true,
          delete : false,
          groupedIds : '',
          descriptionPatch : ['Added'],
          uniqueCode : '',
        }, ...this.invoiceData]
      }
    },
    deleteRow(index) {
      if(this.jurnalStatus == 'Pending' || this.jurnalStatus == 'On Progress') {
        $(`#modalDisableAction`).modal("show");
      } else {
        if(!this.invoiceData[index].invoiceDetailId ) {
        this.invoiceData.splice(index,1)
        } else {
          this.invoiceData[index].delete = true
          this.invoiceData[index].descriptionPatch = ['Deleted']
        }

        this.invoiceData = [...this.invoiceData]
      }
      
    },
    onInput (event, invoiceDetailId, row, field) {
      let index = this.invoiceData.findIndex(item => item.invoiceDetailId == invoiceDetailId)
      let haveChangedIdx = this.changedRowsOldData.findIndex(item => item.invoiceDetailId == this.invoiceData[index].invoiceDetailId)

      if(!invoiceDetailId) {
        index = row
      }
      
      if(haveChangedIdx < 0) {
        this.changedRowsOldData.push({...this.invoiceData[index]})
      } 

      // old price for updating description
      const oldPrice = `Rp ${this.formatPrice(this.invoiceData[index].amount)}`
      
      let value = event.target.innerText
      const numberField = ['qty', 'amount', 'amountDiscount', 'amountTax', 'amountTotal']
      if(field === 'descriptions') {
        value.replace(/(?:\r\n|\r|\n)/g, '<br>');
      }

      if(numberField.includes(field)) {
        value = value.replace(/[.]/g,'')
        value = value.replace(/[,]/g,'.')

        // this.invoiceData[index][field] = Number(value) ? Number(value) : Number(0)
        this.invoiceData[index][field] = value ? Number(value) : Number(0)
        event.target.innerText = this.formatPrice(Number(this.invoiceData[index][field]).toFixed(2))
        if(field == 'amount' || field == 'amountDiscount' || field == 'qty') {
          // this.invoiceData[index].amountTax =  Math.ceil((this.invoiceData[index].amount - this.invoiceData[index].amountDiscount) * this.currentTax)
          // this.invoiceData[index].amountTotal = Math.ceil((this.invoiceData[index].amount + this.invoiceData[index].amountTax - this.invoiceData[index].amountDiscount) * this.invoiceData[index].qty)
          this.invoiceData[index].amountTax =  Math.round((this.invoiceData[index].amount - this.invoiceData[index].amountDiscount) * this.currentTax)
          this.invoiceData[index].amountTotal =(this.invoiceData[index].amount + this.invoiceData[index].amountTax - this.invoiceData[index].amountDiscount) * this.invoiceData[index].qty
          this.invoiceData[index].amount = Number(this.invoiceData[index].amount)

          this.invoiceData[index].amountTotal = Number(this.invoiceData[index].amountTotal).toFixed(2)
          this.invoiceData[index].amountDiscount = Number(this.invoiceData[index].amountDiscount).toFixed(2)
          // For updating Description
          if(field == 'amount' || field == 'amountDiscount' ) {
            const newPrice = `Rp ${this.formatPrice(this.invoiceData[index].amount)}`
            this.invoiceData[index].descriptions = this.invoiceData[index].descriptions.replace(`${oldPrice}`, newPrice )
          }
        }
      } else {
        this.invoiceData[index][field] = value
      }
       
      this.invoiceData = [...this.invoiceData]

    },
    showUpdateBillingDateModal () {
      if(this.jurnalStatus == 'Pending' || this.jurnalStatus == 'On Progress') {
        $(`#modalDisableAction`).modal("show");
      } else {
        this.isExclude = false
        this.newBillingCycle = this.invoiceBillingCycle
        $(`#modalUpdateInvoiceBillingDate`).modal("show");
      }
    },
    showRestoreDataModal () {
      if(this.jurnalStatus == 'Pending' || this.jurnalStatus == 'On Progress') {
        $(`#modalDisableAction`).modal("show");
      } else {
        this.setIsRestoreAll(true)
        $(`#modalRestoreInvoiceDetails`).modal("show");
      }
    },
    closeModal(name){
      $("#modal"+name).modal('hide')
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewDashboard = true
        }
        if( this.permission[i] == "2.1"){
          this.viewOrder = true
        }
        if( this.permission[i] == "2.2"){
          this.editOrder = true
        }
        if( this.permission[i] == '3.1'){
          this.viewReturn = true
        }
        if( this.permission[i] == '3.2'){
          this.editReturn = true
        }
        if( this.permission[i] == '4.1'){
          this.viewProduct = true
        }
        if( this.permission[i] == '4.2'){
          this.editProduct = true
        }
        if( this.permission[i] == '5.1'){
          this.viewPairing = true
        }
        if( this.permission[i] == '5.2'){
          this.editPairing = true
        }
        if( this.permission[i] == '6'){
          this.viewReconcile = true
        }
        if( this.permission[i] == '7.1'){
          this.viewResolution = true
        }
        if( this.permission[i] == '7.2'){
          this.editResolution = true
        }
        if( this.permission[i] == '8.1'){
          this.viewLessor = true
        }
        if( this.permission[i] == '8.2'){
          this.editLessor = true
        }
        if( this.permission[i] == '9.1'){
          this.viewLessee = true
        }
        if( this.permission[i] == '9.2'){
          this.editLessee = true
        }
        if( this.permission[i] == '10'){
          this.viewEmployee = true
        }
         if(this.permission[i] == '21') {
          this.viewInvoicing = true
        }
         if(this.permission[i] == '21.1') {
          this.viewPendingInvoice = true
        }
      }
      if (this.viewPendingInvoice == false) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    getData(){
      this.loadingTable = true

      this.currentPage = parseInt(this.$route.query.page)
      this.itemPerPage = parseInt(this.$route.query.itemPerPage)

      this.$http.post(`${process.env.GET_PENDING_INVOICE_DETAIL}/${this.$route.query.invoiceId}/detail`,
      {
        page: Number(this.$route.query.page),
        itemPerPage : Number(this.$route.query.itemPerPage),
        isPending : true,
      },
      {
        timeout: 20 * 6000,
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if(response.data.status == 303) {
          swal('Oops...','Invoice sudah berhasil dikirim ke jurnal, Klik OK untuk masuk ke detail invoice','error').then(() => {
              this.$router.push({path:`/invoicing/detail/${this.$route.query.invoiceId}`, query: {
                  page : 1,
                  itemPerPage : 10,
                  companyName : this.$route.query.companyName,
                  invoiceId : this.$route.query.invoiceId,
                  jurnalId : '',
                }})
            })
        } else {
          if(response.data.status === 404) {
            swal('Error',response.data.message,'error').then(() => {
            this.$router.push({path:'/invoicing/pending', query: {
                page : 1,
                itemPerPage : 10,
                companyId: '',
                companyName: '',
                billingCycleStart : '',
                billingCycleEnd :'',
                invoiceNumber: '',
                jurnalStatus : '',
                jurnalStatusName : '',  
                orderId : '',
              }})
            })
          } else {
            this.page = response.data.data.currentPage
            this.totalData = response.data.data.totalData
            this.totalPage = response.data.data.totalPage

            this.jurnalStatus = response.data.data.data.jurnalStatus
            this.jurnalSentDate = response.data.data.data.jurnalSentDate
            this.invoiceType = response.data.data.data.invoiceType

            this.isShowLP = response.data.data.data.showLP
            this.inputIsShowLP = response.data.data.data.showLP
            this.isSplitByQty = response.data.data.data.splitByQty
            this.inputIsSplitByQty = response.data.data.data.splitByQty
            this.enableMaterai = response.data.data.data.amountTotal > 5000000 ? true : false
            this.isMaterai = response.data.data.data.materaiUsed
            this.inputIsMaterai = response.data.data.data.materaiUsed
            this.financeEmailList = response.data.data.data.emails
            this.companyName =  response.data.data.data.companyName
            this.companyAddress = response.data.data.data.companyAddress
            this.invoiceBillingCycle = response.data.data.data.billingCycle
            this.invoiceDueDate = response.data.data.data.dueDate,
            this.invoiceId = response.data.data.data.id
            this.invoiceCode = response.data.data.data.invoiceCode
            this.newBillingCycle = response.data.data.data.billingCycle

            this.invoiceData = [...response.data.data.data.responseInvoiceDetails]
            this.changedRowsOldData = []
          
            if(response.data.data.data.showLP) {
              this.invoiceData.forEach(item => {
                if(item.orderCode){
                  item.orderCode = `Order Code : ${item.orderCode.replace(/,/g,', ')}`
                } else {
                  item.orderCode = `Order Code : -`
                }
              })
            }

            if(!this.enableMaterai) {
              this.isMaterai = false
              this.inputIsMaterai = false
            }
          }
        }
       
        this.loadingTable = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          } else {
            this.$router.push({path:'/invoicing/pending', query: {
                page : 1,
                itemPerPage : 10,
                companyId: '',
                companyName: '',
                billingCycleStart : '',
                billingCycleEnd :'',
                invoiceNumber: '',
                jurnalStatus : '',
                jurnalStatusName : '',
                orderId : '',
              }
            })
          }
        })
      })
    },
    sendLog(x){
        var today = new Date();
        var month = today.getMonth()+1
        if (month < 10) {
            month = '0'+month
        }
        var dateDay = today.getDate()
        if (dateDay < 10) {
            dateDay = '0'+dateDay
        }
        var hours = today.getHours()
        if (hours < 10) {
            hours = '0'+hours
        }
        var minutes = today.getMinutes()
        if (minutes < 10) {
            minutes = '0'+minutes
        }
        var second = today.getSeconds()
        if (second < 10) {
            second = '0'+second
        }
        var date = today.getFullYear()+'-'+month+'-'+dateDay;
        var time = hours + ":" + minutes + ":" + second;
        var dateTime = date+' '+time;
        var admin = this.admin
        var command = 'add-logs'
        var productName = this.productNameChoose
        this.$http.post(process.env.LOG_URL+"/ticket/"+x,{
            codeLogs: 36,
            params: [],
        },{
            headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
        })
        .catch(error => {
            console.log(error)
        })
    },
    async getCurrentTax() {
      try {
        const responseData = await this.$http.get(process.env.GET_CURRENT_TAX + `/${this.$route.query.invoiceId}/current-tax`,{
            headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        if (responseData.data.status === 404) {
          throw new Error(responseData.data.message, {cause: 404})
        } else {
          this.currentTax = responseData.data.data.currentTax
        }
      } catch (error) {
        swal("Sorry", error.message || error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response && error.response.data.status == 401) {
            this.handleLogout()
          }
          if ('cause' in error && error.cause == 404) {
            this.$router.push({path:'/invoicing/pending', query: {
              page : 1,
              itemPerPage : 10,
              companyId: '',
              companyName: '',
              billingCycleStart : '',
              billingCycleEnd :'',
              invoiceNumber: '',
              jurnalStatus : '',
              jurnalStatusName : '',  
              orderId : '',
            }})
          }
        })
      }
    }
  },
  async created(){
    this.admin = localStorage.getItem('admin_name')
    this.cekLogin()
    this.cekPermission()

    await this.getCurrentTax()
    this.getData()
  }
}
$(document).ready(function(){
  var self = this
$('#modalCreate').on('hidden.bs.modal', function () {
    // self.wadaw()
});
});
</script>

<style>
.swal-modal .swal-text {
    text-align: center;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.custom-tooltip   {  
  width:16px;
  height:16px;
  border-radius:10px;
  border:2px solid #fff;
  position:relative;
  background:rgba(255,255,255,.5);
}

.custom-tooltip:hover .tooltiptext {visibility:visible;}

.tooltiptext  { 
  width:300px;
  padding:10px;
  background:#ebfdff;
  border-radius:10px;
  position:absolute;
  visibility:hidden;
  box-shadow:0 0 50px 0 rgba(0,0,0,.5);

  font-size: 14px;
}

.progress-box-description{
  font-size: 12px;
  font-style: italic;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
;
}
.progress-box-title {
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

.invoice-action-box-progress {
  border-radius: 0.5rem;
  background-color: #FFDEA5;
}

.bold-12 {
  font-size: 12px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.1%;
  color: #000000;
}
.bold-20 {
  font-size:20px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.1%;
  color: #000000;
}
.bold-24 {
  font-size: 24px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: -0.1%;
  color: #000000;
}
.invoice-category-badge {
  background: #DBEFFE;
  color: #308FF8;
}
.invoice-pending-status-badge {
  background: #EBEEF3;
  color: #5C5C5C;
}
.and-other-email {
  cursor: pointer;
  border: 1px solid;
  border-color: #308FF8;
  color: #308FF8;
  background: #FFFFFF;
}
.table-note {
  color: #0524C8;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 166.667% */
  letter-spacing: -0.012px;
}
.key{
  width: 168px;
  margin: 7px 0px;
}
.titik2{
  margin: 7px 0px;
  padding: 0px 9px;
}
.field{
  width: 100%;
}
.one-line{
  display: flex;
  margin: 4px 0px;
}
.pagination{
padding: 0px 0;
}

.pagination ul{
margin: 0;
padding: 0;
list-style-type: none;
}

.pagination a{
display: inline-block;
padding: 1px 6px;
color: #222;
}

.p8 a{
background-color: #2797FB;
/*margin: auto 5px;*/
color: #fff;
/*font-weight: bold;*/
border: 1px solid #2797FB;
}

.p8 a:hover{
text-decoration: none;
}
.p8 a.page:hover{
text-decoration: none;
color: #fff;
}

.p8 .is-active{
background-color: #fff;
color: #2797FB;
}

.alignleft {
float: left;
}
.alignright {
float: right;
}

.pagg{
display: inline-flex;
overflow:auto;
}

.total-data{
padding: 11px 0px;
font-size: 14px;
color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}

#c1{
 float:left;
}

#c2{
float: right;  
}

.search-table{
padding-bottom: 7px;
margin-top: -5px;
margin-left: -15px;
}
.active{
color: #2797FB;
}
.right-dropdown{
margin-left: 7px;
}
.account-div{
margin: 2px 2px;
}
.right-arrow{
margin-left: auto;
}
.brand-logo{
width: 120px;
}
.menu-title{
margin-left: 1.125rem;
}
.menu-title-order{
margin-left: 1.95rem;
}
.menu-title-payment{
margin-left: 1.525rem;
}

ul {
list-style-type: none;
margin: 0;
padding: 0;
/*width: 200px;*/
/*background-color: #f1f1f1;*/
}

li.sidebar a {
display: block;
color: #000;
padding: 8px 63px;
text-decoration: none;
}

li a.active {
background-color: #4CAF50;
color: white;
}

li a:hover:not(.active) {
background-color: #2797FB;
color: white;
}
.nav-side-menu {
overflow: auto;
font-family: verdana;
font-size: 12px;
font-weight: 200;
background-color: #2e353d;
position: fixed;
top: 0px;
width: 300px;
height: 100%;
color: #e1ffff;
}
.nav-side-menu .brand {
background-color: #23282e;
line-height: 50px;
display: block;
text-align: center;
font-size: 14px;
}
.nav-side-menu .toggle-btn {
display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
list-style: none;
padding: 0px;
margin: 0px;
line-height: 35px;
cursor: pointer;
}
 .nav-side-menu ul :not(collapsed) .arrow:before,
 .nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invoicing/InvoiceCreationPage.vue